import { Search } from "react-bootstrap-icons"
import FormSelect from "../Components/FormTag/FormSelect"
import FormButton from "../Components/Buttons/FormButton"
import { useForm } from "react-hook-form";
import { assemblyPart } from "../Data/dropdownDataList";
import CustomDropdown from "../Components/Dropdown/CustomDropdown";
import { formInvStatus } from "../Data/testData";
import { useEffect, useState } from "react";
import "../assets/css/style.css";
import { useStore } from "../store/Store";
import { CreateKitOrderLayout } from "./CreateKitOrderLayout.type";
import InputFiled from "../Components/FormTag/InputFiled";

const CreateKitOrdersLayout = ({ handleClose }: { handleClose: () => void }) => {

    const handleSubmit = () => {
        handleClose();
    };

    const {
        control,
        register,
        watch,
        formState: { errors },
    } = useForm<CreateKitOrderLayout>({
        defaultValues: new CreateKitOrderLayout()
    });

    interface DataRow {
        [key: string]: any; // Allow any key-value pairs
    }

    const setSelectedItem = useStore((state) => state.setSelectedItem);
    const selectedItem = useStore((state) => state.selectedItem);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        selectedItem && setData(selectedItem);
    }, [selectedItem]);


    const handleSelect = (item: Record<string, any>) => {
        if (selectedItem) {
            item.Line = (selectedItem.length + 1).toString();
            setSelectedItem([...selectedItem, item]);
        } else {
            setSelectedItem(data);
        }
    };

    const columnsConfig = [
        { columnName: "Inv Acct", selector: "inv_acct" },
        { columnName: "Quantity", selector: "quantity" },
    ];

    const toColumnsConfig = [
        { columnName: "Inv Acct", selector: "inv_acct" },
        { columnName: "Assembly Qty", selector: "quantity" },
    ];

    return (
        <>

            <form onSubmit={handleSubmit} className="form">
                <div className="col-12 col-lg-12 col-md-12 mt-2">
                    <div className="row">
                        <div className="col">
                            <div className="px-2">
                                <label className="fw-medium">Assembly Part#</label>
                                <FormSelect
                                    name="assembly_part"
                                    tabIndex={1}
                                    control={control}
                                    optionList={assemblyPart}
                                    required={true}
                                    className="form-control p-0 mt-1"
                                    placeholder={
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Search style={{ marginRight: "5px" }} />
                                            Search
                                        </div>
                                    }
                                    isSearchable={true}
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-2">
                                <label className="fw-medium">From Inv Status</label>
                                <CustomDropdown
                                    isDisabled={watch('assembly_part') ? false : true}
                                    customClassName="customDropDownMenuWidth form-inv-status p-0 mt-1"
                                    data={formInvStatus}
                                    selectableColumns={columnsConfig}
                                    handleSelect={handleSelect}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-12 col-md-12 mt-4">
                    <div className="row">
                        <div className="col">
                            <div className="px-2">
                                <label className="fw-medium">To Inv Status</label>
                                <CustomDropdown
                                    isDisabled={watch('assembly_part') ? false : true}
                                    customClassName="customDropDownMenuWidth form-inv-status p-0 mt-1"
                                    data={formInvStatus}
                                    selectableColumns={toColumnsConfig}
                                    handleSelect={handleSelect}
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-2">
                                <label className="fw-medium">Order Qty</label>
                                <InputFiled
                                    type="text"
                                    tabIndex={4}
                                    register={register}
                                    required={true}
                                    name="order_qty"
                                    errors={errors.orderQty}
                                    className="form-control mt-1"
                                    placeholder="Enter"
                                />
                            </div>
                        </div>
                    </div>
                </div><div className="col-12 col-lg-12 col-md-12 mt-4">
                    <div className="row">
                        <div className="col">
                            <div className="px-2">
                                <p className="text-secondary"> Qty available to Reverse:</p>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className=" border-2 border-secondary" />

                <div className="d-flex justify-content-end mt-4 gap-2">
                    <FormButton
                        tabIndex={26}
                        className="sph-btn sph-shift"
                        handleClick={() => handleClose()}>
                        Cancel
                    </FormButton>
                    <FormButton
                        tabIndex={25}
                        className="sph-btn me-2"
                        handleClick={() => handleClose()}>
                        Submit
                    </FormButton>
                </div>
            </form >
        </>
    )

}

export default CreateKitOrdersLayout